import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hse-risk',
  templateUrl: './hse-risk.component.html',
  styleUrls: ['./hse-risk.component.scss']
})
export class HSERiskComponent implements OnInit {

  src = '../../../../../assets/file/INDUKSI.pdf';

  constructor() { }

  ngOnInit(): void {
  }

}
